export default "__VITE_ASSET__CFANBNH9__"